import TimesheetsView from '../components/views/Timesheets';

export default TimesheetsView;
